<div class="payment-details-cont">
    <form [formGroup]="savedPaymentItemForm" class="payment-form">
        <div *ngIf="savedPaymentItems === undefined" style="margin: auto;">
            <mat-spinner [diameter]="35" class="col-xs-offset-6"></mat-spinner>
        </div>
        <div *ngIf="savedPaymentItems?.length == 0 ">
            <p class="no-saved-card"> No saved card found </p>
        </div>

        <div *ngIf="savedPaymentItems?.length > 0 ">
            <div class="select-the-card">
                <p>Select the card</p>
            </div>
            <div *ngFor="let savedPaymentItem of savedPaymentItems">
                <div class="saved-card">
                    <div class="row">
                        <div class="col-sm-9">
                            <input type="radio" [value]="savedPaymentItem" formControlName="cardToken"
                            [(ngModel)]="selectedPaymentDetail" (ngModelChange)="onSavedPaymentSelect()"/>
                            <label>
                                <p class="m-0 font-bold">{{savedPaymentItem.card_name}}</p>
                                <p class="m-0 card-number">{{savedPaymentItem.card_no}}</p>
                            </label>
                        </div>
                        <mat-form-field class="col-sm-3 cvv-wrapper"
                            *ngIf="savedPaymentItemForm.value.cardToken == savedPaymentItem">
                            <div class="row">
                                <div class="col-xs-9">
                                    <input type="password" matInput formControlName="cardCVV" placeholder="CVV"
                                    onKeyPress="if(this.value.length == 3) return false;"
                                    style="letter-spacing: 10.3px;"
                                    [(ngModel)]="paymentRequest.paymentDetails.cardDetails.cardCVV">
                                </div>
                                <div class="col-xs-2">
                                    <app-tooltip placement="left">
                                        <i class="fa fa-info-circle" trigger></i>
                                        <div content style="width: 30vw; max-width: 200px">
                                            <div class="row p-0 m-0">
                                                <p class="col-xs-12">
                                                    The CVV is a 3 digits number on the back of your card
                                                </p>
                                            </div>
                                        </div>
                                    </app-tooltip>
                                </div>
                            </div>
                            <mat-error class="error-message" *ngIf="savedPaymentItemControles.cardCVV.invalid">Please enter valid CVV
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="row" *ngIf="savedPaymentItemForm.value.cardToken == savedPaymentItem">
                        <div class="convenience-fee-box">
                            <p class="convenience-fee-text"> Convenience fee of <strong class="text-style-1"> {{getpayUConvenienceFee()
                                    |currency:'INR':'symbol':'2.2'}}
                                </strong> (Incl of {{payUConvenienceFeeGSTPercentage}}% GST)
                                <strong class="text-style-1">waived off by Finzy </strong>
                                <app-tooltip placement="bottom">
                                    <i class="fa fa-info-circle text-style-1 info-icon" trigger></i>
                                    <div content style="width: 35vw; max-width: 250px">
                                        <div class="row p-0 m-0">
                                            <p class="col-xs-12">
                                                The waiver of convenience fee is for a limited period and subject to change after <strong>March
                                                    31st 2022</strong>
                                            </p>
                                        </div>
                                    </div>
                                </app-tooltip>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="showViewAllButton">
            <a id="display-all-saved-payment-item" (click)="showFullSavedPaymentList()">VIEW ALL</a>
        </div>
    </form>
</div>
